import React from "react";
import { Form } from "react-bootstrap";
import PropTypes from "prop-types";

class TextInput extends React.Component {
  render() {
    const {
      id,
      fieldType,
      placeholder,
      value,
      onChange,
      name,
      readOnly,
      onKeyPress,
      disabled,
      style,
      accept,
    } = this.props;

    return (
      <Form.Control
        id={id}
        type={fieldType}
        accept={accept}
        placeholder={placeholder}
        className="textForm"
        value={value}
        name={name}
        onChange={onChange}
        readOnly={readOnly}
        onKeyPress={onKeyPress}
        disabled={disabled}
        style={style}
      />
    );
  }
}

TextInput.propTypes = {
  fieldType: PropTypes.string,
};

export default TextInput;
